if (!customElements.get("collection-load-more")) {
  customElements.define(
    "collection-load-more",
    class CollectionLoadMore extends HTMLElement {
      constructor() {
        super();
        this.changeUrl = this.dataset.changeUrl == "true";

        if (this.button) {
          this.button.addEventListener(
            "click",
            this.handleButtonClick.bind(this)
          );
        }
      }
      get button() {
        return this.querySelector("a");
      }

      handleButtonClick(e) {
        e.preventDefault();
        if (this.children.length == 0) {
          return;
        }
        this.loadNextPage();
      }

      changePageInURL(pageNumber) {
        if (!this.changeUrl) return;
        if (pageNumber == undefined) return;

        let url = new URL(window.location);
        url.searchParams.set("page", pageNumber);
        window.history.pushState({}, "", url);
      }

      loadNextPage() {
        if (this.button == null) return;

        let url = this.button.href;
        this.button.classList.add("loading");
        let urlObject = new URL(url);
        let nextPageNumber = urlObject.searchParams.get("page");

        fetch(url)
          .then((response) => response.text())
          .then((responseText) => {
            this.changePageInURL(nextPageNumber);
            const html = responseText;
            const parsedResponse = new DOMParser().parseFromString(
              html,
              "text/html"
            );
            let productGrid = parsedResponse.querySelector(
              "[data-productgrid-items]"
            );
            let ogProductGrid = document.querySelector(
              "[data-productgrid-items]"
            );
            let productGridChildren = Array.from(productGrid.children);

            if (productGridChildren.length) {
              productGridChildren.forEach((child) => {
                let clonedChild = child.cloneNode(true);
                ogProductGrid.append(clonedChild);
              });
            }

            //trigger the lazyloading library to re-render images
            document.dispatchEvent(new CustomEvent("theme:rimg:watch"));

            const ogLoadMoreButtons = document.querySelectorAll(
              "collection-load-more a"
            );
            const newLoadMoreSection = parsedResponse.querySelector(
              "collection-load-more"
            );

            if (newLoadMoreSection) {
              let newLoadMoreButton = newLoadMoreSection.querySelector("a");
              ogLoadMoreButtons.forEach(
                (button) => (button.href = newLoadMoreButton.href)
              );
              this.button.classList.remove("loading");
            } else {
              ogLoadMoreButtons.forEach((button) => button.remove());
            }
          });
      }
    }
  );
}